export interface DashboardLayoutSlotStyle {
    left: number;
    top: number;
    width: number;
    height: number;
}

interface SlotInfo {
    count: number[];
    getHeight: () => number;
    getStyle: (important: boolean, slot: number) => DashboardLayoutSlotStyle;
}

// Splits the interval 0.."value" in ("sliceCount"+"importantSliceCount"+1) parts.
// Eg: if value is 100 and "sliceCount" is 2, the result is [0, 50, 100]
// The "importantSliceCount" slices are wider by "importantScale".
function slice(value: number, sliceCount: number, importantSliceCount: number, importantRight: boolean, importantScale: number): number[] {
    const slices: number[] = [0]; // The first slice is always at 0
    const importantValue = (value * importantSliceCount * importantScale) / (sliceCount + importantSliceCount * importantScale);
    const addSlices = (start: number, partValue: number, count: number) => {
        for (let i = 1; i <= count; i++) {
            slices.push(Math.floor(start + (partValue * i) / count));
        }
    };
    if (importantRight) {
        addSlices(0, value - importantValue, sliceCount);
        addSlices(value - importantValue, importantValue, importantSliceCount);
    } else {
        addSlices(0, importantValue, importantSliceCount);
        addSlices(importantValue, value - importantValue, sliceCount);
    }
    return slices;
}

function makeColumnedGetSlotInfo(importantSlots: number, importantRight: boolean, slotWidth: number, maxHeight: number) {
    const IMP_SCALE = 1.41;
    return (top: number, width: number): SlotInfo => {
        let count = importantSlots + Math.floor((width - importantSlots * slotWidth * IMP_SCALE) / slotWidth);
        if (count < 1) {
            count = 1;
        } else if (count > 4) {
            count = 4;
        }
        const importantCount = Math.min(importantSlots, count);
        const xs = slice(width, count - importantCount, importantCount, importantRight, IMP_SCALE);
        const height = Math.min(maxHeight, xs[1] - xs[0]);
        return {
            count: [count - importantCount, importantCount],
            getHeight: () => height,
            getStyle: (important: boolean, slot: number): DashboardLayoutSlotStyle => {
                const slot_ = important ? slot : importantCount + slot;
                return {
                    left: xs[slot_],
                    top,
                    width: xs[slot_ + 1] - xs[slot_],
                    height,
                };
            },
        };
    };
}

const dashboardLayout1 = makeColumnedGetSlotInfo(1, false, 400, 300);
const dashboardLayout2 = makeColumnedGetSlotInfo(1, true, 300, 300);

const dashboardLayouts = [dashboardLayout1, dashboardLayout2];

export type NextDashboardStyle = (important: boolean) => DashboardLayoutSlotStyle;

export function makeNextDashboardStyle(width: number): NextDashboardStyle {
    let slotIndex: number[];
    let slotInfo: SlotInfo;
    let layoutIndex = 0;
    let top = 0;

    const init = () => {
        slotIndex = [0, 0];
        slotInfo = dashboardLayouts[layoutIndex](top, width);
    };

    const next = (important: boolean): DashboardLayoutSlotStyle => {
        const importance = important ? 1 : 0;
        if (slotIndex[importance] < slotInfo.count[importance]) {
            return slotInfo.getStyle(important, slotIndex[importance]++);
        }
        if (slotIndex[1 - importance] < slotInfo.count[1 - importance]) {
            return slotInfo.getStyle(!important, slotIndex[1 - importance]++);
        }
        top += slotInfo.getHeight();
        layoutIndex++;
        if (layoutIndex >= dashboardLayouts.length) {
            layoutIndex = 0;
        }

        init();
        return next(important);
    };

    init();
    return next;
}



// WEBPACK FOOTER //
// ./src/views/DashboardLayout.tsx